export default __webpack_public_path__ + "static/media/dra-debora.bd9b988e.png";